// extracted by mini-css-extract-plugin
export default {"container":"Create_container__UzucX","inputContainer":"Create_inputContainer__F0rUI","antiBot":"Create_antiBot__VGo6G","selectContainer":"Create_selectContainer__yWDrg"};